"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NexusLoader = exports.NexusDefaultSettings = void 0;
const nexus_viewer_lib_1 = require("nexus-viewer-lib");
const utils_1 = require("../utils/utils");
nexus_viewer_lib_1.Nexus.meshcoder = 'assets/meco.js';
class NexusDefaultSettings {
}
exports.NexusDefaultSettings = NexusDefaultSettings;
NexusDefaultSettings.TARGET_ERROR = 3; // 0.1 lower
NexusDefaultSettings.TARGET_FPS = 60;
NexusDefaultSettings.MAX_PENDING = 6;
NexusDefaultSettings.MAX_BLOCKED = 5;
NexusDefaultSettings.MAX_CACHE_SIZE = 512 * (1 << 20); // N * 1MB (2 ^ 20)
NexusDefaultSettings.DRAW_BUDGET = 16 * (1 << 20); // N * 1MB (2 ^ 20)
class NexusLoader {
    load(webgl, url, loaderManager, tokenProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: something from props || default
            nexus_viewer_lib_1.Nexus.getContext(webgl.renderer.getContext()).settings.targetError = NexusDefaultSettings.TARGET_ERROR;
            nexus_viewer_lib_1.Nexus.getContext(webgl.renderer.getContext()).settings.targetFps = NexusDefaultSettings.TARGET_FPS;
            nexus_viewer_lib_1.Nexus.getContext(webgl.renderer.getContext()).settings.maxPending = NexusDefaultSettings.MAX_PENDING;
            nexus_viewer_lib_1.Nexus.getContext(webgl.renderer.getContext()).settings.maxBlocked = NexusDefaultSettings.MAX_BLOCKED;
            nexus_viewer_lib_1.Nexus.getContext(webgl.renderer.getContext()).settings.maxCacheSize = NexusDefaultSettings.MAX_CACHE_SIZE;
            nexus_viewer_lib_1.Nexus.getContext(webgl.renderer.getContext()).settings.drawBudget = NexusDefaultSettings.DRAW_BUDGET;
            if ((0, utils_1.isUrlPrivate)(url) && tokenProvider === undefined) {
                throw new Error("Jwt token calback is not defined");
            }
            return new Promise((res, rej) => {
                nexus_viewer_lib_1.Nexus.createObject(url, webgl.renderer, () => webgl.renderOnce(), (nexus_obj) => res(nexus_obj), tokenProvider);
            });
        });
    }
}
exports.NexusLoader = NexusLoader;
